import { useEffect } from "react";

// While the portal is mounted (spec 3.5): <html> carries te-portal-doc and data-te-mode, the browser chrome
// turns navy, the viewport allows the safe-area insets, and the tab says which screen the client is on.
// Everything is captured before it is changed and restored on cleanup, so the CRM is untouched afterwards.
// enabled=false is the App-level loading screen's case: the child effect must not fight the page's own.
export const PORTAL_THEME_COLOR = "#203043";

export default function usePortalDocument({ mode, title, enabled = true }) {
  useEffect(() => {
    if (!enabled) return undefined;
    const html = document.documentElement;
    const hadClass = html.classList.contains("te-portal-doc");
    const prevMode = html.getAttribute("data-te-mode");
    const theme = document.querySelector('meta[name="theme-color"]');
    const prevTheme = theme ? theme.getAttribute("content") : null;
    const vp = document.querySelector('meta[name="viewport"]');
    const prevVp = vp ? vp.getAttribute("content") : null;
    const prevTitle = document.title;

    html.classList.add("te-portal-doc");
    html.setAttribute("data-te-mode", mode || "app");
    if (theme) theme.setAttribute("content", PORTAL_THEME_COLOR);
    if (vp && prevVp && prevVp.indexOf("viewport-fit") === -1) {
      vp.setAttribute("content", `${prevVp}, viewport-fit=cover`);
    }
    if (title) document.title = title;

    return () => {
      if (!hadClass) html.classList.remove("te-portal-doc");
      if (prevMode === null) html.removeAttribute("data-te-mode");
      else html.setAttribute("data-te-mode", prevMode);
      if (theme && prevTheme !== null) theme.setAttribute("content", prevTheme);
      if (vp && prevVp !== null) vp.setAttribute("content", prevVp);
      document.title = prevTitle;
    };
  }, [enabled, mode, title]);
}
